import { useContext, useMemo } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { Button, Typography } from '@mui/material'
import { enqueueSnackbar } from 'notistack'

import { AppContext } from '/providers/app-context'
import { archiveTemplate } from '/providers/templates-api'
import PageWrapper from '/components/page-wrapper'
import Menu from '/components/templates/template-nav-menu'
import HelpText from '/help/template-archive'

const TemplateArchive = () => {
  const { templateId } = useParams()
  const navigate = useNavigate()
  const { apiSource, apiKey, loadingTemplates, templates, refreshTemplates, processing, setProcessing } = useContext(AppContext)
  const template = useMemo(() => templates.find(item => item.template_id === templateId) ?? null, [templates, templateId])
  if (!loadingTemplates && (!template || template.archived)) return <Navigate to='/templates' replace />

  const archive = async () => {
    setProcessing(true)
    const result = await archiveTemplate({ apiSource, apiKey, templateId })
    setProcessing(false)
    if (result?.error || result?.ok === false) return enqueueSnackbar({ message: result?.error?.message ?? 'Unable to archive template', variant: 'error' })
    await refreshTemplates()
    enqueueSnackbar({ message: 'Template archived', variant: 'success' })
    navigate('/templates')
  }

  return <PageWrapper title={template ? `Archive Template (${template.name})` : 'Archive Template'} HelpText={HelpText} heading='Archive template' selectedTemplate={template} menu={<Menu template={template} processing={processing} setProcessing={setProcessing} />}>
    <div className='p-5 max-w-2xl flex flex-col gap-5'>
      <Typography variant='h4'>Archive template</Typography>
      <Typography>Archive <strong>{template?.name}</strong>? It will be retained with its history, but cannot be edited or used to issue new passes until it is unarchived.</Typography>
      <div className='flex gap-3'><Button onClick={() => navigate(`/templates/${templateId}/details`)} disabled={processing}>Cancel</Button><Button variant='contained' onClick={archive} disabled={processing}>Archive template</Button></div>
    </div>
  </PageWrapper>
}

export default TemplateArchive
